import _extends from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React from 'react';
var SvgCameraIconWhite = function SvgCameraIconWhite(props) {
  return __jsx("svg", _extends({
    height: "29",
    viewBox: "0 0 34 29",
    width: "34",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), __jsx("mask", {
    id: "a",
    fill: "#fff"
  }, __jsx("path", {
    d: "m.04.102h1.699v5.362h-1.699z",
    fill: "#fff",
    fillRule: "evenodd"
  })), __jsx("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.257 .301)"
  }, __jsx("path", {
    d: "m10.504 7.321c.284-.523 1.035-.857 1.603-.857h7.154c.568 0 1.318.334 1.603.857l1.192 1.747c.237.476.712.809 1.28.809h3.815c.853 0 1.517.714 1.517 1.524v11.927a1.53 1.53 0 0 1 -1.517 1.523h-22.793c-.852 0-1.515-.714-1.515-1.523v-11.975c0-.857.71-1.524 1.515-1.524h3.912c.189-.047.426-.095.568-.19a.922.922 0 0 0 .426-.428zm13.329-.396-.592-.936c-.758-1.476-2.227-2.428-3.933-2.428h-7.153c-1.658 0-3.174.952-3.932 2.428l-.647.936h-3.218a4.357 4.357 0 0 0 -4.358 4.38v12.023a4.357 4.357 0 0 0 4.358 4.379h22.793a4.358 4.358 0 0 0 4.36-4.379v-11.975c0-2.428-1.944-4.428-4.36-4.428z",
    fill: "#fff"
  }), __jsx("ellipse", {
    cx: "16.046",
    cy: "16.704",
    rx: "4.883",
    ry: "4.9",
    stroke: "#fff",
    strokeWidth: "2.318"
  }), __jsx("g", {
    fill: "#fff"
  }, __jsx("path", {
    d: "m25.227 5.246-1.03-1.65a.827.827 0 0 1 .26-1.134.817.817 0 0 1 1.126.26l1.03 1.65a.826.826 0 0 1 -.258 1.133.82.82 0 0 1 -1.128-.26"
  }), __jsx("path", {
    d: "m.89 5.464a.854.854 0 0 1 -.85-.853v-3.656c0-.47.383-.855.85-.855.466 0 .849.384.849.854v3.656c0 .47-.383.853-.85.853",
    mask: "url(#a)",
    transform: "translate(27.942 .166)"
  }), __jsx("path", {
    d: "m30.965 4.494.858-1.747a.82.82 0 0 1 1.096-.374c.402.2.57.696.37 1.101l-.857 1.747a.818.818 0 1 1 -1.467-.727"
  }))));
};
export default SvgCameraIconWhite;